import { Component } from '@angular/core';
import { TextButtonComponent, TooltipDirective } from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-remove-access-button',
  styleUrls: ['./ag-remove-access-button.component.scss'],
  templateUrl: './ag-remove-access-button.component.html',
  imports: [TextButtonComponent, TooltipDirective],
})
export class AgEditRemoveAccessButtonComponent implements ICellRendererAngularComp {
  params: any;
  removeDisabled = false;
  editDisabled = false;
  showRemoveBtn = true;
  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.editDisabled = this.params.data.editDisabled;
    this.removeDisabled = this.params.data.removeDisabled;
    this.showRemoveBtn = this.params.isApproveUserFlow
      ? false
      : this.params.showRemoveBtn || this.params.data.role !== 'Owner';
  }

  btnClickedHandler(action: string, _event?: any): void {
    this.params.clicked(action, this.params.data);
  }
}
